/** Generic placeholder tab for not-yet-implemented model sections. */
import { useTranslation } from "react-i18next";
import PortalEmptyState from "../../../components/portal/PortalEmptyState";

export default function AdminModelTabPlaceholder({ titleKey, icon }) {
  const { t } = useTranslation();
  return (
    <div data-testid="model-tab-placeholder" className="py-8">
      <PortalEmptyState
        variant="dashed"
        icon={icon}
        titleKey={titleKey}
        descKey="admin.placeholder.soon_desc"
      />
    </div>
  );
}
